module.exports = __webpack_public_path__ + "static/media/curtiss_sarikey.c8054d29.png";